import React from 'react';
import { TableSalesReportWrapper } from './TableSalesReport.style';
import Table from 'components/ui-kits/Table';
import CardInvoicesMerchantTable from './ItemSalesReport';
import { formatDollar } from 'utils';

interface Iprops {
  onDataTable: any;
}

const headerTable = [
  { label: '' },
  { label: 'Qté.' },
  { label: 'Prix unitaire (HT)' },
  { label: 'Réduction' },
  { label: 'Total HT' },
  { label: 'TVA' },
  { label: 'Montant TVA' },
  { label: 'Total TTC' }
];

const TableSalesReport = ({ onDataTable }: Iprops) => {
  return (
    <TableSalesReportWrapper>
      <Table header={headerTable}>
        {onDataTable ? (
          <>
            <CardInvoicesMerchantTable
              type="Formule STANDARD"
              qty={1}
              unitPriceHT={onDataTable.priceHT * 100}
              discount={onDataTable.discount}
              totalHT={onDataTable.totalPriceHT * 100}
              vat={onDataTable.vat}
              vatAmount={onDataTable.vatAmount * 100}
              totalTTC={onDataTable.amount * 100}
            />
          </>
        ) : (
          <tr>
            <td colSpan={8}></td>
          </tr>
        )}
        <tr className="row-total">
          <td colSpan={4}></td>
          <td>{`${formatDollar(onDataTable.totalPriceHT * 100)} €`}</td>
          <td></td>
          <td>{`${formatDollar(onDataTable.vatAmount * 100)} €`}</td>
          <td>{`${formatDollar(onDataTable.amount * 100)} €`}</td>
        </tr>
        <tr className="footer">
          <td colSpan={8}>
            <div className="footerContent">
              Achil SAS / 3 Les Vinottes, 25500 Morteau / n° TVA : FR
              11889430765
            </div>
            <div className="footerContent">
              R.C.S Besançon 889 430 765, Société au capital de 92 500€
            </div>
          </td>
        </tr>
      </Table>
    </TableSalesReportWrapper>
  );
};

export default TableSalesReport;
